import { render } from "./AttachmentsAccordion.vue?vue&type=template&id=5846e187&scoped=true"
import script from "./AttachmentsAccordion.vue?vue&type=script&lang=js"
export * from "./AttachmentsAccordion.vue?vue&type=script&lang=js"

import "./AttachmentsAccordion.vue?vue&type=style&index=0&id=5846e187&scoped=true&lang=less"
const cssModules = {}
import style1 from "./less/attachments.less?vue&type=style&index=1&module=true&lang=css&external"
cssModules["$style"] = style1

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-5846e187"]])

export default __exports__